import { useState } from "react"
import { deleteExpense, updateExpense } from "../../../../services/axios"
import formatMoney from "../../../../services/utils/formatMoney"
import Editable from "./editable"
import { useNotification } from "../../../../components/useNotification"
import { isoToDateStr } from "../../../../services/utils/iso_to_date_string"

const Item = ({getExpensesByDate, unities, row}) => {
    const [showEditable, setShowEditable] = useState(false)
    const {Notification, showNotification } = useNotification()

    const handleDeleteExpense = async ()=>{
        if (window.confirm('Tem certeza que deseja deletar essa despesa?')){
            try {
                await deleteExpense(row.id)
                getExpensesByDate()
                showNotification({text: 'Despesa deletada!', type: 'ok'})
            } catch (error) {
                Promise.reject(error)
                showNotification({text: 'Erro ao deletar despesa.', type: 'error'})
            }
        }else{
            showNotification({text: 'Operação cancelada. Nada foi deletado.', type: 'warning'})
        }
    }

    return(
        <>
        {Notification}
        <tr className='valueRow despesasRow'>
            <td className='value tdName'>
                {row?.name}
            </td>
            <td className='value'>
                {row?.description}
            </td>
            <td className='value tdValue'>
                {isoToDateStr(row.reference_date)}
            </td>
            <td className='value tdValue'>
                {formatMoney(row?.value)}
            </td>
            <td>
            { row?.id > 0 && row?.name.toLowerCase() != 'repasse' &&
                <>
                    <span onClick={() => setShowEditable(prev => !prev)} className="material-symbols-outlined EDIcons">edit</span>
                    <span onClick={handleDeleteExpense} className="material-symbols-outlined EDIcons">delete</span>
                </>
            }
            </td>
        </tr>
        {showEditable && (
           <Editable getExpensesByDate={getExpensesByDate} unities={unities} row={row} setShowEditable={setShowEditable}/>
        )}
        </>
    )}

export default Item